module.exports = __webpack_public_path__ + "static/media/banner_alibaba_ss@2x.82621c38.jpg";